export default __webpack_public_path__ + "static/appjamming20191-4720bc608607139d39fd0949c401aea5.jpg";